import { webApiRoute } from '@crm/shared/api';

import type { TCompany } from '../model';

export const companyApiRoutes = {
    getAvailableCompaniesRoute: () => webApiRoute('companies'),
    setActiveCompanyRoute: (companyId: TCompany['id']) =>
        webApiRoute(`companies/${companyId}/set-active`),
};
